const gefaesspartie = [
	"",
	"RS",
	"WS",
	"WSv",
	"BS",
	"HS",
	"Gv",
	"AT",
	"DS"
]

export default gefaesspartie;
